var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.items && _vm.items.length)?_c('v-row',[_c('span',{staticClass:"subtitle-1 pl-3",domProps:{"textContent":_vm._s('Localização')}}),_c('v-col',{attrs:{"cols":"12"}},[_c('v-data-table',{attrs:{"items":_vm.items,"hide-default-footer":"","headers":[
        { text: 'Localização', value: 'localizacao' },
        { text: 'Tombo', value: 'tombo' },
        { text: 'Volume', value: 'volume' },
        { text: 'Tomo', value: 'tomo' },
      ]}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }